import React, { useState } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import SiteLogo from "../../Assets/images/siteLogoWhite.svg";
import LogoInitial from "../../Assets/images/SiteLogoInitial.png";
import { NavLink, useNavigate } from "react-router-dom";
import {
  Stack,
  Button,
  Tooltip,
  IconButton,
  Drawer,
  useMediaQuery,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { userType } from "../../../redux/reducers/userData";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import { changeLightMode } from "../../../redux/reducers/GlobalVariables";
import MenuIcon from "@mui/icons-material/Menu";

const agent_32 = "http://demo.d-crm.in/doc/dcrmagent_32.zip";
const agent_64 = "http://demo.d-crm.in/doc/dcrmagent_64.zip";
//const agent_32 = "https://mt.d-crm.in/doc/dcrmagent_32.zip";
//const agent_64 = "https://mt.d-crm.in/doc/dcrmagent_64.zip";

function OuterHeader1({ companyLogo, companyUrl }) {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width:600px)");
  const lightMode = useSelector((state) => state.GlobalVariables.lightMode);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuClose = () => {
    setIsMenuOpen(false);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: "transparent",
          height: 64, // ✅ fixed height
          justifyContent: "center",
        }}
      >
        <Toolbar
          disableGutters
          sx={{
            minHeight: 64, // ✅ override default MUI height
            px: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* LOGO */}
          <Box sx={{ width: "auto", display: "flex", alignItems: "center" }}>
            <a href={companyUrl} target="_blank" rel="noopener noreferrer">
              <Box
                component="img"
                src={SiteLogo}
                alt="Dovetail"
                sx={{
                  filter: lightMode ? "invert(1)" : "invert(0)",
                  width: 140,
                  display: { xs: "none", sm: "block" },
                }}
              />
            </a>

            <a href={companyUrl} target="_blank" rel="noopener noreferrer">
              <Box
                component="img"
                src={LogoInitial}
                alt="Dovetail"
                sx={{
                  filter: lightMode ? "invert(0)" : "invert(1)",
                  width: 48,
                  display: { xs: "block", sm: "none" },
                }}
              />
            </a>
          </Box>

          {/* RIGHT ACTIONS */}
          <Stack direction="row" spacing={2} alignItems="center">
            <IconButton
              sx={{ display: { xs: "inline", sm: "none" } }}
              onClick={handleMenuToggle}
            >
              <MenuIcon sx={{ color: lightMode ? "#333" : "#fff" }} />
            </IconButton>
            <Drawer
              anchor="top"
              open={isMenuOpen}
              onClose={handleMenuClose}
              sx={{ "& .MuiPaper-root": { backgroundColor: "transparent" } }}
            >
              {" "}
              <Box p={2}>
                {" "}
                <Stack direction="column" spacing={2}>
                  {" "}
                  <Button
                    variant="text"
                    sx={{ color: lightMode ? "#ffffff" : "#333" }}
                    onClick={() => {
                      dispatch(changeLightMode());
                      handleMenuClose();
                    }}
                  >
                    {" "}
                    {lightMode ? (
                      <Tooltip title="Dark Mode">
                        {" "}
                        <DarkModeOutlinedIcon
                          sx={{ color: lightMode ? "#ffffff" : "#ffffff" }}
                        />{" "}
                      </Tooltip>
                    ) : (
                      <Tooltip title="Light Mode">
                        {" "}
                        <LightModeOutlinedIcon
                          sx={{ color: lightMode ? "#ffffff" : "#ffffff" }}
                        />{" "}
                      </Tooltip>
                    )}{" "}
                  </Button>{" "}
                </Stack>{" "}
              </Box>{" "}
            </Drawer>
            {!isMobile && (
              <IconButton onClick={() => dispatch(changeLightMode())}>
                {lightMode ? (
                  <Tooltip title="Dark Mode">
                    <DarkModeOutlinedIcon sx={{ color: "#333" }} />
                  </Tooltip>
                ) : (
                  <Tooltip title="Light Mode">
                    <LightModeOutlinedIcon sx={{ color: "#fff" }} />
                  </Tooltip>
                )}
              </IconButton>
            )}
          </Stack>
        </Toolbar>
      </AppBar>

      {/* Spacer to avoid content hiding behind fixed AppBar */}
      <Box sx={{ height: 64 }} />
    </Box>
  );
}

export default OuterHeader1;
